import { Injectable } from "@angular/core";
import { APIService } from "src/app/shared/services/api.service";
import { Constants } from "src/app/shared/constants";

@Injectable()
export class ScreenPopService {

  constructor(private _APIService: APIService) { }

  insertToDatabase(data: any) {
    return this._APIService.post(data, Constants.Screen_Pop_API_URLS.insertToDatabase);
  }
  logMessage(data: any) {
    return this._APIService.post(data, Constants.Screen_Pop_API_URLS.logMessage);
  }
  logException(data: any) {
    return this._APIService.post(data, Constants.Screen_Pop_API_URLS.logException);
  }
  getQuestionsAndShutdownReasons(countryId: number, languageId: number) {
    return this._APIService.get(Constants.Screen_Pop_API_URLS.getQuestionsAndShutdownReasons + `${countryId}&${languageId}`);
  }
  getTokens(identity: string) {
    return this._APIService.get(Constants.Screen_Pop_API_URLS.getTokens + identity);
  }
  modifyMicGainWin(uuid: any, elevatorId: any, value: any, command: any) {
    return this._APIService.post({ uuid: uuid, elevatorId: elevatorId, value: value, methodName: command }, Constants.Screen_Pop_API_URLS.modifyMicGainWin);
  };

  getQuestionTextAShutdownReason(objIds: any) {
    return this._APIService.post(objIds, Constants.Screen_Pop_API_URLS.modifyMicGainWin);
  };

  modifySpeakerVolWin(uuid: any, elevatorId: any, value: any, command: any) {
    return this._APIService.post({ uuid: uuid, elevatorId: elevatorId, value: value, methodName: command }, Constants.Screen_Pop_API_URLS.modifySpeakerVolumeWin);
  };

  insertChatMsgDetails(msgDetails: any) {
    return this._APIService.post(msgDetails, Constants.Screen_Pop_API_URLS.insertChatMsgDetails);
  };

  getWinElevatorInfo(call: any) {
    let urlParams = `alarmId=${call.alarmId}&carId=${call.carId}&countryId=${call.countryId}&countryShortName=${call.countryShortName}&direction=${call.direction}&elevatorId=${call.elevatorId}&failure=${call.failure}&floor=${call.floor}&initiator=${call.initiator}&roomSid=${call.roomSid}&uniqueId=${call.uniqueId}&workerId=${call.workerId}`;
    
    return this._APIService.get(Constants.Screen_Pop_API_URLS.getWinElevatorInfo + '?' + urlParams);
  };

  getWinToken(roomName: any) {
    return this._APIService.get(Constants.Screen_Pop_API_URLS.getWinToken + roomName);
  };

  completeCall(objCall: any) {
    return this._APIService.post(objCall, Constants.Screen_Pop_API_URLS.completeCall);
  };

  getRoomDetails(roomName: any) {
    return this._APIService.get(Constants.Screen_Pop_API_URLS.roomDetails + roomName);
  };

  languageString(page: any) {
    return this._APIService.get(Constants.Screen_Pop_API_URLS.languageString + page);
  }

}
